// extracted by mini-css-extract-plugin
export default {"popover":"popover___BzWKm","container":"container___EsOhp","btn":"btn___UQWAf","btnPicture":"btnPicture___qr9_0","attachment":"attachment___SzvOG"};